import axios from 'axios';

const publicClient = axios.create({
    baseURL: window.configuration?.API_BASE_URL,
});

export const validatePublicSchedulingCalendar = ({ shareLinkId, tenantId }) =>
    publicClient
        .get('Public/SchedulingCalendar/Validate', {
            params: { shareLinkId, tenantId },
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendar = ({ shareLinkId, tenantId, password, filterPayload }) =>
    publicClient
        .post('Public/SchedulingCalendar/GetCalendar', {
            shareLinkId,
            tenantId,
            password,
            ...(filterPayload || {}),
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendarPrivilegedRads = ({ shareLinkId, tenantId, password, facilityIds }) =>
    publicClient
        .post('Public/SchedulingCalendar/GetPrivilegedRads', {
            shareLinkId,
            tenantId,
            password,
            facilityIds,
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendarAdhocDropdowns = ({ shareLinkId, tenantId, password }) =>
    publicClient
        .get('Public/SchedulingCalendar/GetAdhocDropdowns', {
            params: { shareLinkId, tenantId, password },
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendarTaskDropdown = ({ shareLinkId, tenantId, password }) =>
    publicClient
        .get('Public/SchedulingCalendar/GetAllTask', {
            params: { shareLinkId, tenantId, password },
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendarRadiologistDropdown = ({ shareLinkId, tenantId, password }) =>
    publicClient
        .get('Public/SchedulingCalendar/GetAllRadiologistQgendaScheduleEnterpriseDropdown', {
            params: { shareLinkId, tenantId, password },
        })
        .then((response) => response.data);

export const fetchPublicSchedulingCalendarTaskFacilities = ({ shareLinkId, tenantId, password, taskId }) =>
    publicClient
        .get('Public/SchedulingCalendar/GetTaskFacilities', {
            params: { shareLinkId, tenantId, password, taskId },
        })
        .then((response) => response.data);

export const exportPublicSchedulingCalendar = ({ shareLinkId, tenantId, password, filterPayload, tenantTimeZoneCode }) =>
    publicClient
        .post('Public/SchedulingCalendar/ExportToCSV', {
            shareLinkId,
            tenantId,
            password,
            ...(filterPayload || {}),
            tenantTimeZoneCode,
        })
        .then((response) => response.data);
